interface CardItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  imageUrl: string;
  imageAlt: string;
}

const cardItems: CardItem[] = [
  {
    id: 1,
    title: '热血战斗漫画推荐：燃到停不下来',
    desc: '精选热血战斗类漫画，从经典到新番，每一部都让你肾上腺素飙升。香香漫画免费下拉畅快追更，燃爆整个夏天。',
    tag: '热血冒险',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20style%20illustration%2C%20epic%20battle%20scene%20with%20energy%20effects%2C%20warm%20coral%20and%20amber%20tones%2C%20watercolor%20ink%20artistic%20style%2C%20powerful%20composition%2C%20soft%20gradient%20background%2C%20professional%20quality%2C%20high%20detail&width=600&height=400&seq=card-manga-01&orientation=landscape',
    imageAlt: '香香漫画 - 热血战斗漫画推荐',
  },
  {
    id: 2,
    title: '国漫崛起：不可错过的国产佳作',
    desc: '近年来国漫质量飞速提升，这几部作品代表了国产漫画的最高水平。香香漫画全集免费，支持国产原创漫画。',
    tag: '国漫推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20style%20manga%20illustration%2C%20traditional%20ink%20painting%20aesthetic%20with%20martial%20arts%20theme%2C%20warm%20coral%20and%20amber%20tones%2C%20watercolor%20artistic%20style%2C%20elegant%20composition%2C%20soft%20background%20with%20mountains%2C%20professional%20quality%2C%20high%20detail&width=600&height=400&seq=card-manga-02&orientation=landscape',
    imageAlt: '香香漫画 - 国漫佳作推荐',
  },
  {
    id: 3,
    title: '周末一口气追完的短篇漫画',
    desc: '精选完结短篇漫画，剧情紧凑不拖沓。周末一杯奶茶的时间，下拉式阅读畅享完整故事，体验不一样的心流阅读。',
    tag: '短篇精品',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20manga%20reading%20scene%2C%20open%20manga%20book%20with%20colorful%20illustrations%2C%20warm%20coral%20and%20golden%20amber%20lighting%2C%20watercolor%20artistic%20style%2C%20comfortable%20composition%20with%20soft%20natural%20light%2C%20editorial%20quality%2C%20high%20detail&width=600&height=400&seq=card-manga-03&orientation=landscape',
    imageAlt: '香香漫画 - 短篇漫画推荐',
  },
  {
    id: 4,
    title: '悬疑漫画入坑指南：烧脑又上瘾',
    desc: '喜欢推理和反转？这几部悬疑漫画绝对让你欲罢不能。每一页都是线索，下拉阅读层层递进的紧张感加倍刺激。',
    tag: '悬疑推理',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20style%20illustration%2C%20atmospheric%20dark%20scene%20with%20dramatic%20lighting%2C%20warm%20amber%20and%20deep%20coral%20tones%2C%20watercolor%20ink%20artistic%20style%2C%20suspenseful%20composition%2C%20soft%20dark%20gradient%20background%2C%20professional%20quality%2C%20high%20detail&width=600&height=400&seq=card-manga-04&orientation=landscape',
    imageAlt: '香香漫画 - 悬疑漫画推荐',
  },
  {
    id: 5,
    title: '少女漫画颜值天花板合集',
    desc: '画风精美到每一帧都想截图的少女漫画合集。从古风到现代，精致的人物设计和浪漫剧情，下拉阅读沉浸感满分。',
    tag: '少女漫画',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20shojo%20manga%20style%20illustration%2C%20elegant%20character%20with%20flowers%20and%20soft%20lighting%2C%20warm%20coral%20rose%20and%20gentle%20pink%20tones%2C%20watercolor%20artistic%20style%2C%20dreamy%20atmosphere%2C%20clean%20harmonious%20composition%2C%20professional%20quality%2C%20high%20detail&width=600&height=400&seq=card-manga-05&orientation=landscape',
    imageAlt: '香香漫画 - 少女漫画推荐',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">推荐专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">为你精选的漫画阅读指南与专题推荐</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full aspect-[3/2] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <span className="inline-block text-[10px] font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full mb-2 self-start">{item.tag}</span>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-3 cursor-pointer whitespace-nowrap">
                  了解更多 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          ))}
          {cardItems.slice(3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer sm:col-span-2 lg:col-span-2 flex flex-col sm:flex-row"
            >
              <div className="overflow-hidden sm:w-2/5 shrink-0">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full sm:w-full h-48 sm:h-full aspect-[3/2] sm:aspect-auto object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <span className="inline-block text-[10px] font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full mb-2 self-start">{item.tag}</span>
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-3 cursor-pointer whitespace-nowrap">
                  了解更多 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}